(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hero = document.querySelector('[data-pt-hero]');
  var heroText = document.querySelector('[data-pt-hero-text]');
  var wordsSections = document.querySelectorAll('[data-pt-words]');
  var revealEls = document.querySelectorAll('[data-pt-reveal]');
  var parallaxEls = document.querySelectorAll('[data-pt-parallax]');

  if (reduceMotion) {
    revealEls.forEach(function (el) { el.classList.add('pt-is-visible'); });
    return;
  }

  var ticking = false;

  function apply() {
    ticking = false;
    var sy = window.scrollY || document.documentElement.scrollTop || 0;
    var vh = window.innerHeight;
    var narrow = window.innerWidth < 860;

    if (hero) {
      var p = Math.min(1, sy / (vh * 0.9));
      var e = p * (narrow ? 0.5 : 1);
      hero.style.transform = 'translate(-50%,-50%) translate3d(0,' + (e * vh * 0.05).toFixed(1) + 'px,0) scale(' + (1 + e * 0.42).toFixed(3) + ') rotate(' + (p * (narrow ? 3 : 6)).toFixed(2) + 'deg)';
      var base = narrow ? 0.6 : 0.78;
      hero.style.opacity = (base * (1 - p * 0.4)).toFixed(3);
    }
    if (heroText) {
      var pt = Math.min(1, sy / (vh * 0.5));
      heroText.style.opacity = (1 - pt).toFixed(3);
      heroText.style.transform = 'translate3d(0,' + (-pt * 70).toFixed(1) + 'px,0)';
    }

    wordsSections.forEach(function (c) {
      var t = c.querySelector('p') || c;
      var tr = t.getBoundingClientRect();
      var p2 = Math.min(1, Math.max(0, (0.95 - tr.top / vh) / 0.62));
      var ws = c.querySelectorAll('[data-pt-word]');
      ws.forEach(function (w, i) {
        var start = (i / ws.length) * 0.86;
        var o = Math.min(1, Math.max(0, (p2 - start) / 0.14));
        w.style.opacity = (0.45 + o * 0.55).toFixed(3);
      });
    });

    revealEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9) el.classList.add('pt-is-visible');
    });

    parallaxEls.forEach(function (el) {
      var s = parseFloat(el.getAttribute('data-pt-parallax')) || 0.1;
      s *= narrow ? 0.35 : 1;
      var r = el.getBoundingClientRect();
      var c = Math.max(-1, Math.min(1, (r.top + r.height / 2 - vh / 2) / vh));
      el.style.transform = 'translate3d(0,' + (-c * s * 110).toFixed(2) + 'px,0)';
    });
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(apply);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', apply);
  apply();
})();
